
var ViewFactory = require('tplify/dist/viewFactory').default;

delete module.exports;

var viewFactory = new ViewFactory('<div class="signaturesPresenter-wrapper">\n    <div class="signaturesPresenter-proofOfDeparture">\n        <h1 class="signaturesPresenter-title">Proof of Departure</h1>\n        <img class="signaturesPresenter-signatureImage" data-name="proofOfDepartureImage">\n        <p class="signaturesPresenter-name" data-name="proofOfDepartureName"></p>\n    </div>\n\n    <div class="signaturesPresenter-proofOfDelivery">\n        <h1 class="signaturesPresenter-title">Proof of Delivery</h1>\n        <img class="signaturesPresenter-signatureImage" data-name="proofOfDeliveryImage">\n        <p class="signaturesPresenter-name" data-name="proofOfDeliveryName"></p>\n    </div>\n</div>\n');

Object.defineProperty(module, 'exports', {
get: function() {
    return viewFactory.create();
}
});
